export default "__VITE_ASSET__cf33141a__"